export const ROUTES_NAME = {
  HOME: '',
  LOGIN: 'login',
  PATIENT: 'patient',
  PRACTICE: 'practice',
  PRACTICE_TEMPLATE: 'practice-template',
  DOCUMENTS: 'documents',
  PROFILE: 'profile',
  PRINT: 'print',
} as const;
